/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { axiosInstance } from "../utils/axiosInstance";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import GoogleSignIn from "./GoogleSignIn";
import FacebookLoginn from "./FacebookLogin";
import { useState } from "react";

function SignInForm() {
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  // Validation schema for form fields
  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

  // Initial form values
  const initialValues = {
    email: "",
    password: "",
  };

  // Handle form submission
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      // Replace with your API endpoint
      const response = await axiosInstance.post("user/login", values);
      if (response.data.status == true) {
        toast.success("Login successfully");
        localStorage.setItem("token", response.data.token);
        navigate("/userprofile");
      }
    } catch (error) {
      const { message } = error?.response?.data;
      toast.error(message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container" style={{ height: "100vh" }}>
      <div className="row align-items-center h-100">
        <div className="col-lg-5 col-md-6">
          <img
            src="/images/loginImg.png"
            className="img-fluid d-block my-auto"
            alt="Login Illustration"
          />
        </div>
        <div className="col-lg-6 col-md-6 ms-auto">
          <img
            src="/images/registerLogo.png"
            className="w-25 d-block mx-auto pb-4"
            alt="Register Logo"
          />
          <h1 className="fw-bolder text-black fs-2 py-2">Sign In</h1>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form>
                <label className="fw-bolder text-secondary fs-6 pt-1">
                  Email Address
                </label>
                <Field
                  type="email"
                  name="email"
                  className="form-control border-2 border-secondary py-2 fw-semibold"
                  placeholder="hello@example.com"
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="text-danger"
                />

                <label className="fw-bolder text-secondary fs-6 pt-3">
                  Password
                </label>
                <div className="position-relative">
                  <Field
                    type={showPassword ? "text" : "password"}
                    name="password"
                    className="form-control border-2 border-secondary py-2 fw-semibold pe-5"
                    placeholder="Password"
                  />
                  <button
                    type="button"
                    className="btn btn-link position-absolute end-0 top-50 translate-middle-y me-2"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{ color: "#6c757d" }}
                  >
                    <i
                      className={`fas fa-eye${showPassword ? "-slash" : ""}`}
                    />
                  </button>
                </div>
                <ErrorMessage
                  name="password"
                  component="div"
                  className="text-danger"
                />

                <div className="d-flex gap-2 pt-2 align-items-center">
                  <input
                    className="form-check-input border-3 px-2 py-2 border-secondary"
                    type="checkbox"
                  />
                  <label className="form-check-label fw-bold text-secondary">
                    Remember my preference
                  </label>
                </div>

                <p className="d-flex gap-2 pt-1 mb-0">
                  <Link
                    to={"/forgetpassemail"}
                    className="text-decoration-none"
                  >
                    Forgot Password?
                  </Link>
                </p>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="btn btn-danger w-100 fw-bold py-2 fs-6"
                  style={{ background: "#CD2128", border: "none" }}
                >
                  {isSubmitting ? "Signing In..." : "Sign In"}
                </button>
              </Form>
            )}
          </Formik>
          {/* Social Login and Additional Links */}
          <div className="d-flex gap-2 align-items-center justify-content-center py-3">
            <div
              style={{
                padding: "2px 0px",
                width: "10%",
                background: "#EEEEEE",
              }}
            />
            <p className="text-center m-0 text-secondary">Continue With</p>
            <div
              style={{
                padding: "2px 0px",
                width: "10%",
                background: "#EEEEEE",
              }}
            />
          </div>
          <div className="d-flex flex-wrap gap-2 align-items-center justify-content-center py-3">
            <FacebookLoginn />

            <GoogleSignIn />
            {/* <button className="btn btn-light border border-secondary px-4 py-2 d-flex align-items-center gap-2">
              <i
                className="fab fa-linkedin"
                style={{ color: "#3B579D", fontSize: 20 }}
              />
              <span className="fs-5">LinkedIn</span>
            </button> */}
          </div>
          <Link
            to={"/signup"}
            className="btn btn-link text-secondary text-center d-block text-decoration-none"
          >
            Create An Account? <span className="text-danger">Sign Up</span>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default SignInForm;
